// extracted by mini-css-extract-plugin
module.exports = {"bookDropContent":"BookDropContent_bookDropContent__22Io6","bookDropContent__previewInput":"BookDropContent_bookDropContent__previewInput__cJW1b"};